import { VALID, INVALID, CAN_NOT_BE_SANITIZED } from '../shared-constants';
export var MALE_NATIONAL_ID = 'male';
export var FEMALE_NATIONAL_ID = 'female';
export { VALID, INVALID, CAN_NOT_BE_SANITIZED };